import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { Drawer, MenuItem, Snackbar, IconButton, Divider } from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import connectPropTypes from './utilities/connectPropTypes'
import Icon from './components/Icon'
import TopAppBar from './components/TopAppBar'
import BottomAppBar from './components/BottomAppBar'
import BottomNavBar from './components/BottomNavBar'
import Routes from './Routes'
import messageTypes from './enums/messageTypes'
import styles from './App.icss'

class App extends Component {
	constructor(props) {
		super(props)

		this.handleToggle = this.handleToggle.bind(this)
		this.handleDrawerClose = this.handleDrawerClose.bind(this)
		this.handleSnackbarHide = this.handleSnackbarHide.bind(this)
		this.handleLogout = this.handleLogout.bind(this)
	}

	handleSnackbarHide() {
		this.props.appShowSnackbar(false)
	}

	handleToggle() {
		this.props.appDrawerOpen(!this.props.drawerOpen)
	}

	handleDrawerClose() {
		this.props.appDrawerOpen(false)
	}

	handleLogout() {
		this.props.appDrawerOpen(false)
		this.props.appRedirect('/login')
		this.props.authLogout()
	}

	render() {
		const keyPostfix = this.props.history.location.pathname + this.props.history.location.search
		if (this.props.pageHasLoaded) {
			global.hideLoadingSpinner()
		} else {
			global.showLoadingSpinner()
		}
		return (
			<div>
				<div className={styles.app + (this.props.pageHasLoaded ? ` ${styles.appPageHasLoaded}` : '')}>
					{this.props.showTopBar && (
						<Drawer
							anchor="right"
							width={200}
							open={this.props.drawerOpen}
							onClick={this.handleDrawerClose}
							onKeyDown={this.handleDrawerClose}
						>
							<MenuItem onClick={this.handleDrawerClose} style={{ color: '#ccc' }}>{this.context.translate('Close menu')}</MenuItem>
							{this.props.contextMenus && this.props.contextMenus.length > 0 && (
							<>
								{this.props.contextMenus.map(menu => (
									<MenuItem
										onClick={() => {
											this.handleDrawerClose()
											if (menu.func) {
												menu.func()
											}
										}}
										key={JSON.stringify(menu)}
									>
										{menu.link &&
											<Link className={styles.menuLink} to={menu.link}>{menu.text}</Link>
										}
										{!menu.link &&
											<span className={styles.menuLink}>{menu.text}</span>
										}
									</MenuItem>
								))}
								<Divider />
							</>
							)}
							<MenuItem onClick={this.handleDrawerClose}><Link className={styles.menuLink} to="/">{this.context.translate('Home')}</Link></MenuItem>
							{this.props.user && this.props.user.userProfile && this.props.user.userProfile.userName &&
								<MenuItem onClick={this.handleDrawerClose}><Link className={styles.menuLink} to={`/user/${this.props.user.userProfile.userName}`}> {this.context.translate('User profile')}</Link></MenuItem>
							}
							{this.props.location.pathname !== '/report' && this.props.location.pathname !== '/feedback' && (
								<>
									<MenuItem onClick={this.handleDrawerClose}>
										<Link className={styles.menuLink} to={`/report?url=${global.encodeURIComponent(global.location.href)}&location=${global.encodeURIComponent(JSON.stringify(this.props.location))}`}>{this.context.translate('Report problem')}</Link>
									</MenuItem>
									<MenuItem onClick={this.handleDrawerClose}>
										<Link className={styles.menuLink} to={`/feedback?url=${global.encodeURIComponent(global.location.href)}&location=${global.encodeURIComponent(JSON.stringify(this.props.location))}`}>{this.context.translate('Feedback')}</Link>
									</MenuItem>
								</>
							)}
							{this.props.user.isAdmin && (
								<>
									<Divider />
									<MenuItem onClick={this.handleDrawerClose}>
										<Link className={styles.menuLink} to="/item/edit?addNewItem=true" onClick={() => this.props.searchParametersClear()}>
											<Icon name="blackItem" className={styles.menuIcon} />
											{this.context.translate('Add an item')}
										</Link>
									</MenuItem>
									<MenuItem onClick={this.handleDrawerClose}><Link className={styles.menuLink} to="/login">Log in</Link></MenuItem>
									<MenuItem onClick={this.handleDrawerClose}><Link className={styles.menuLink} to="/hackme">Hacker Helper™</Link></MenuItem>
									<Divider />
								</>
							)}
							<MenuItem onClick={this.handleDrawerClose}>
								<a href="https://kit.fit/terms" target="_blank" rel="noreferrer noopener" className={styles.tpLink}>{this.context.translate('Terms of use')}</a>
							</MenuItem>
							<MenuItem onClick={this.handleDrawerClose}>
								<a href="https://kit.fit/privacy" target="_blank" rel="noreferrer noopener" className={styles.tpLink}>{this.context.translate('Privacy')}</a>
							</MenuItem>
							<Divider />
							<MenuItem onClick={this.handleLogout}>Logout</MenuItem>
						</Drawer>
					)}

					{this.props.showTopBar && (
						<TopAppBar
							backButtonFunction={(this.props.backButtonFunction === true ? () => this.props.history.goBack() : this.props.backButtonFunction)}
							heading={this.props.heading}
							handleToggle={this.handleToggle}
						/>
					)}

					<div className={this.props.backgroundImage ? '' : styles.routes}>
						<Routes keyPostfix={keyPostfix} />
					</div>

					{this.props.showBottomBar && (
						<BottomAppBar />
					)}

					{this.props.showBottomNavBar && (
						<BottomNavBar
							value={this.props.bottomNavBarValue}
							handleClick={this.props.bottomNavBarHandleClick}
							labelNext={this.props.bottomNavBarLabelNext}
						/>
					)}

					{this.props.message && (
						<Snackbar
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'center'
							}}
							open={this.props.showSnackbar}
							autoHideDuration={6000}
							onClose={this.handleSnackbarHide}
							ContentProps={{ 'aria-describedby': 'message-id' }}
							message={(
								<span id="message-id">
									{this.props.messageType && this.props.messageType === messageTypes.INFO &&
									<span>INFO: </span>
									}
									<span>{this.props.message}</span>
								</span>
							)}
							action={[
								<IconButton
									key="close"
									aria-label="Close"
									onClick={this.handleSnackbarHide}
								>
									<Close />
								</IconButton>
							]}
						/>
					)}
				</div>
				{this.props.backgroundImage &&
					<div className={this.props.backgroundWhite ? styles.backgroundImageUnderlay : styles.backgroundImageUnderlayWhite} />
				}
				{this.props.backgroundImage &&
					<div className={styles.backgroundImage} style={{ backgroundImage: `url(${this.props.backgroundImage})` }} />
				}
			</div>
		)
	}
}

App.propTypes = {
	/* eslint-disable react/forbid-prop-types  */
	history: PropTypes.object.isRequired,
	location: PropTypes.shape({
		search: PropTypes.string,
		pathname: PropTypes.string.isRequired
	}).isRequired,
	heading: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.bool
	]).isRequired,
	showTopBar: PropTypes.bool.isRequired,
	showBottomBar: PropTypes.bool.isRequired,
	showBottomNavBar: PropTypes.bool.isRequired,
	showSnackbar: PropTypes.bool.isRequired,
	bottomNavBarValue: PropTypes.object.isRequired,
	bottomNavBarLabelNext: PropTypes.string.isRequired,
	contextMenus: PropTypes.array.isRequired,
	bottomNavBarHandleClick: PropTypes.func.isRequired,
	backButtonFunction: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.bool
	]).isRequired,
	appDrawerOpen: PropTypes.func.isRequired,
	backgroundImage: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool
	]).isRequired,
	backgroundWhite: PropTypes.bool.isRequired,
	appRedirect: PropTypes.func.isRequired,
	appShowSnackbar: PropTypes.func.isRequired,
	searchParametersClear: PropTypes.func.isRequired,
	pageHasLoaded: PropTypes.bool.isRequired,
	message: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool
	]).isRequired,
	messageType: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.bool
	]).isRequired,
	drawerOpen: PropTypes.bool.isRequired,
	authLogout: PropTypes.func.isRequired,
	user: PropTypes.shape({
		isAdmin: PropTypes.bool,
		userProfile: PropTypes.shape({
			userName: PropTypes.string
		})
	}).isRequired
}

App.contextTypes = {
	translate: PropTypes.func
}

export const testing = {
	App
}

export default withRouter(connectPropTypes(App))



// WEBPACK FOOTER //
// ./src/App.js